import { createLazyComponent, LazyModule } from 'owa-bundling';
var messageAdReadingPaneLazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "MessageAdReadingPane" */ './lazyIndex');
});
// Export delay loaded components
export var MessageAdReadingPane = createLazyComponent(messageAdReadingPaneLazyModule, function (m) { return m.MessageAdReadingPane; });
//# sourceMappingURL=index.js.map